import { ComponentType } from '@wix/ambassador-devcenter-components-v1-component/types';

export const ALLOWED_EXTENSIONS = [
  ComponentType.CUSTOM_ELEMENT_WIDGET,
  ComponentType.STUDIO_WIDGET,
];

export const BUILDER_BASED_ALLOWED_EXTENSIONS = [
  ComponentType.EDITOR_REACT_COMPONENT,
  ComponentType.CUSTOM_ELEMENT_WIDGET,
];
